import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";

export class GetPurchaserBrandsUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(purchaserId: number) {
    return this.purchaserRepository.getPurchaserBrands(purchaserId);
  }
}
